// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d665a8d4","389":"7fc6ab81","453":"20629176","455":"baef5887","604":"ca9d5fba"}[chunkId] + ".chunk.js";
};